import '../src/legacy/ui.js';

import '../../app/assets/javascripts/functions.js';
import '../../app/assets/javascripts/doctors.js';
import '../../app/assets/javascripts/nurse.js';
import '../../app/assets/javascripts/appointments.js';
import '../../app/assets/javascripts/modules/hmo_radio_options.js';
import '../../app/assets/javascripts/modules/hmo_plan.js';
import '../../app/assets/javascripts/modules/native_webcam.js';
import '../../app/assets/javascripts/modules/medical_history.js';
import '../../app/assets/javascripts/modules/add_consultation.js';
import '../../app/assets/javascripts/modules/add_medical_document.js';
import '../../app/assets/javascripts/modules/add_lab_results.js';
import '../../app/assets/javascripts/modules/clinic_status.js';
import '../../app/assets/javascripts/modules/printables.js';
import '../../app/assets/javascripts/modules/android-interfaces.js';
import '../../app/assets/javascripts/es6_modules/autosave_soap.es6';
import '../../app/assets/javascripts/utils/modal.js';
import '../../app/assets/javascripts/utils/file_preview_renderer.js';
import '../../app/assets/javascripts/utils/file_viewer.js';
import '../../app/assets/javascripts/utils/dropdown.js';
import '../../app/assets/javascripts/utils/collapse.js';
import '../../app/assets/javascripts/utils/text_clamp.js';
import '../../app/assets/javascripts/utils/tab.js';
import '../../app/assets/javascripts/utils/split_panel.js';
import '../../app/assets/javascripts/utils/compare_split.js';
import '../../app/assets/javascripts/utils/compare_file_viewer.js';
import '../../app/assets/javascripts/utils/compare_tab_sync.js';
import '../../app/assets/javascripts/utils/compare_section_jump.js';
import '../src/legacy/secret_word_form.js';
import '../../app/assets/javascripts/utils/idle_timeout.js';
import { initDatepickers } from '../src/legacy/init-datepickers.js';

window.initDatepickers = initDatepickers;

import Turbolinks from 'turbolinks';

window.Turbolinks = Turbolinks;
Turbolinks.start();

// $(function()...) handles the case where this script executes after the
// initial turbolinks:load event has already fired (e.g., deferred scripts).
// turbolinks:load handles subsequent page navigations. The idempotency
// guard in initDatepickers prevents double-initialization if both fire.
// (Idempotency of this dual-binding is tested in init-datepickers.spec.js.)
$(function() {
    initDatepickers($);
});

$(document).on("turbolinks:load", function() {
    initDatepickers($);
});
